exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media only screen and (max-width:600px){.breadcrumbs{margin-left:24px!important}.breadcrumbs__item .icon{font-size:16px!important;width:20px!important;height:20px!important;padding:12px!important}.breadcrumbs__item .menu__activator{padding-left:0!important;margin:0 -5px!important}.breadcrumbs__item .menu__activator .icon{height:40px!important}.breadcrumbs__item .menu__activator.menu__activator--active{margin-top:-15px!important}.format-badge{margin-right:5px!important}.breadcrumbs li:first-child:not(:last-child) .breadcrumb--title{display:none}.breadcrumbs li:first-child:not(:last-child) .format-badge{margin-right:-5px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/header/Breadcrumbs.vue
// module id = 1064
// module chunks = 22